module.exports = __webpack_public_path__ + "static/media/hero-banner-sm.78b439b1.jpg";